import { Component, Mixins, Vue } from "vue-property-decorator";

export default function i18NextMixinFactory(
  i18nextNS: string,
  resources: { [key: string]: object },
  defaultLanguage: string
) {
  if (Vue.prototype.hasOwnProperty("$i18n")) {
    return Component(
      class I18NextMixin extends Vue {
        created() {
          // @ts-ignore
          const i18next = this.$i18n.i18next;
          for (const lang of Object.keys(resources)) {
            if (!i18next.hasResourceBundle(lang, i18nextNS)) {
              i18next.addResourceBundle(lang, i18nextNS, resources[lang]);
            }
          }
        }

        t(text: string): string {
          /**
           * Check `i18nLoadedAt` to always depend reactively on the chosen language.
           */
          // @ts-ignore
          if (this.$i18n.i18nLoadedAt) {
            // @ts-ignore
            if (this.$i18n.i18next.language === defaultLanguage) {
              return text;
            }

            // @ts-ignore
            return this.$t(text, {
              ns: i18nextNS,
              nsSeparator: false,
              keySeparator: false
            });
          } else {
            return text;
          }
        }
      }
    );
  } else {
    return Component(
      class I18NStub extends Vue {
        t(text: string): string {
          return text;
        }
      }
    );
  }
}
